module.exports = __webpack_public_path__ + "img/menu-dots-icon.6c83b0c4.svg";